module.exports = __webpack_public_path__ + "img/stu_avatar_class.32eec462.jpg";